export const USER_ADDRESS_COMPONENT = 'USER_ADDRESS_COMPONENT';

export const BILLING_ADDRESS_COMPONENT = 'BILLING_ADDRESS_COMPONENT';

export const BILLING_ADDRESS_SECTION_ID = 'billing-address-section';

export const USER_ADDRESS_SECTION_ID = 'user-address-section';
